import { Controller } from 'stimulus'

// "Learn more" links (HelpHelper#help_link) open their guide in a slide-over
// beside the current screen instead of navigating away. The controller sits on
// the layout's page wrapper; the drawer markup is layouts/application/_help_drawer.
export default class extends Controller {
  static targets = ['drawer', 'body', 'scrim']

  open(event) {
    // Modifier-clicks keep their browser meaning: open the full article in a new tab.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return
    event.preventDefault()

    const link = event.currentTarget
    this.opener = link
    this.element.classList.add('help-drawer-open')
    this.bodyTarget.innerHTML = '<div class="help-drawer-loading">Loading the guide&hellip;</div>'

    fetch(link.dataset.helpUrl, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(response => {
        if (!response.ok) throw new Error(`Guide request failed: ${response.status}`)
        return response.text()
      })
      .then(html => {
        this.bodyTarget.innerHTML = html
        this.drawerTarget.focus()
        this.scrollToAnchor(link.dataset.helpAnchor)
      })
      .catch(() => {
        const fallback = document.createElement('a')
        fallback.href = link.href
        fallback.textContent = 'Open it in the Help Center.'
        const message = document.createElement('div')
        message.className = 'help-drawer-loading'
        message.textContent = 'This guide could not be loaded. '
        message.appendChild(fallback)
        this.bodyTarget.innerHTML = ''
        this.bodyTarget.appendChild(message)
      })
  }

  close() {
    if (!this.element.classList.contains('help-drawer-open')) return
    this.element.classList.remove('help-drawer-open')
    if (this.opener) this.opener.focus()
  }

  keydown(event) {
    // A video opened from the drawer closes first (help_video_controller.js).
    if (event.key === 'Escape' && !document.querySelector('.help-player-scrim:not([hidden])')) this.close()
  }

  scrollToAnchor(anchor) {
    if (!anchor) return
    const target = this.bodyTarget.querySelector(`#${CSS.escape(anchor)}`)
    if (target) target.scrollIntoView({ block: 'start' })
  }
}
